/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { llmModelsListOrgPrices } from "../../funcs/llmModelsListOrgPrices.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.ListOrgPricesRequest$inboundSchema,
};

export const tool$llmModelsListOrgPrices: ToolDefinition<typeof args> = {
  name: "llm-models-list-org-prices",
  description: `List an org's price overrides

Without \`model\`, lists the org's current overrides. With \`model\`, returns that override's dated history.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await llmModelsListOrgPrices(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
